import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import _ from 'lodash'

import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles';

import { TextInput, SelectInput, ReferenceSelectInput } from '../Inputs'


const styles = {
  button: {
    icon: {
      marginRight: '10px'
    }
  }
}

class CertificationFilters extends Component {

  renderChoices(choices) {
    return _.map(choices, choice => {
      return (
        <MenuItem value={choice.value} key={choice.value}>
            {choice.text}
        </MenuItem>
      )
    })
  }

  render() {
    const {
      classes,
      handleSubmit,
      tipoInstalacionChoices,
      decretoChoices,
    } = this.props

    return (
        <form
            onSubmit={handleSubmit(values => this.props.onSubmit(values))}
            className={classes.form}
        >
          <Grid container spacing={16}>
            <Grid item xs={12} md={2} lg={4}>
              <Field
                name={"tipoInstalacion"}
                label={"Tipo Instalación"}
                required={false}
                component={SelectInput}
                disabled={!!!tipoInstalacionChoices}
                onChange={this.props.onChange()}
              >
                {!!tipoInstalacionChoices && this.renderChoices(tipoInstalacionChoices)}
              </Field>
            </Grid>
            <Grid item xs={12} md={2} lg={4}>
              <Field
                name={"decreto"}
                label={"Decreto"}
                required={false}
                component={SelectInput}
                disabled={!!!decretoChoices}
                onChange={this.props.onChange()}
              >
                {!!decretoChoices && this.renderChoices(decretoChoices)}
              </Field>
            </Grid>
            <Grid item xs={12} md={2} lg={4}>
              <Field
                name={"empresa"}
                label={"Empresa"}
                required={false}
                component={ReferenceSelectInput}
                reference={"empresas"}
                optionText={"name"}
                isDisabled={false}
                onChange={this.props.onChange()}
              />
            </Grid>
            <Grid item xs={12} md={2} lg={4}>
              <Field
                name={"search"}
                type="text"
                label={"Buscar por Nombre"}
                component={TextInput}
                disabled={!!!decretoChoices}
                onChange={this.props.onSearchChange()}
              />
            </Grid>
          </Grid>

        </form>
    )
  }
}

export default reduxForm({
    form: 'redux-form'
})(withStyles(styles)(CertificationFilters))
